import React from 'react';
import { useAppSelector } from '../app/hooks';
import { useIsDirectionOutOfRange } from '../app/is-direction-out-of-range-hook';
import { useAppDispatch } from '../app/store';
import { appendMonth, goToNextMonth, goToPreviousMonth } from '../features/calendar/calendar-slice';
import { SvgIcon } from './svg-icon';

export const MonthPagination = () => {
    const dispatch = useAppDispatch();
    const appendMonths = useAppSelector(state => state.calendar.appendMonths);
    const { loadMoreEventsButtonText, previousMonthButtonText, nextMonthButtonText } = useAppSelector(state => state.settings);
    const eventsAreLoading = useAppSelector(state => state.calendar.eventsAreLoading);

    const [nextOutOfRange, prevOutOfRange] = useIsDirectionOutOfRange();

    return (
        <div className="ace-cal-pagination">
            {
                appendMonths ?
                    <button type="button" className="btn btn-load-more" onClick={(e) => dispatch(appendMonth())} disabled={eventsAreLoading || nextOutOfRange} data-testid="pagination loadMore">{loadMoreEventsButtonText}</button>
                    :
                    <div className="flex-between">
                        <button type="button" className="btn-secondary" onClick={(e) => dispatch(goToPreviousMonth())} disabled={eventsAreLoading || prevOutOfRange} data-testid="pagination previous">
                            <SvgIcon iconId="icon-chevron-left" cssClass="svg-icon-sm" />
                            <span>{previousMonthButtonText}</span>
                        </button>
                        <button type="button" className="btn-secondary" onClick={(e) => dispatch(goToNextMonth())} disabled={eventsAreLoading || nextOutOfRange} data-testid="pagination next">
                            <span>{nextMonthButtonText}</span>
                            <SvgIcon iconId="icon-chevron-right" cssClass="svg-icon-sm" />
                        </button>
                    </div>
            }
        </div>
    );
}